import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, Subscription } from 'rxjs';
import { ColDef } from 'ag-grid-community';
import { AgGridAngular } from 'ag-grid-angular';
import * as agGrid from 'ag-grid-community';
import { routes } from '../../../../shared/routes/routes';
import { ambulancdeHistory } from '../../../../shared/models/models';
import { ApiService } from '../../../../api.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  standalone: false,
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
})
export class HistoryComponent {
  public tooltipShowDelay = 0;
  public tooltipHideDelay = 2000;
  SerachedRow: number | undefined;
  paginationPageSize = 10;
  currentPage: number = 1;
  visiblePageCount = 5;
  startPage = 1;
  fromRecord = 0;
  toRecord = 0;
  totalRecords = 0;
  paging: number[] = [];
  lastElementOfPage: number = 0;
  NoRecordsFound!: boolean;
  public routes = routes;
  showLogoutConfirm = false;
  public tableData2: Array<ambulancdeHistory> = [];
  selectedTabIndex = 0;
  private gridApi: any;
  private gridColumnApi: any;
  public totalTableData: Array<ambulancdeHistory> = [];
  userProfile: any = {};
  telemedicineFeature: any;
  completionPercentage = 0;
  public pageSize = 10;
  gridOptions!: agGrid.GridOptions;
  public searchDataValue = '';
  public serialNumberArray: Array<number> = [];
  public totalData = 0;
  showFilter = false;
  totalPage: number = 0;
  currPage: number = 0;
  private paginationSubscription!: Subscription;
  recordListing: any = [];
  dataSource2!: MatTableDataSource<ambulancdeHistory>;
  dependentData: any = [];
  selected_id: any;
  showApologies: boolean = false;
  subDetail: any;
  reportIdToDelete: any;
  showDeleteModal: boolean = false;
  showApology: boolean = false;
  private destroy$ = new Subject<void>();
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
  };
  rowData: any = [];

  colDefs: ColDef[] = [
    {
      headerName: 'S.NO',
      valueGetter: (params: any) => {
        const rowNode = params.node;
        const model = params.api.getModel();
        const allRows: any[] = [];
        model.forEachNodeAfterFilterAndSort((node: any) => {
          allRows.push(node);
        });
        const globalIndex = allRows.findIndex((node) => node === rowNode);
        return globalIndex + 1;
      },
      minWidth: 80,
      flex: 0.5,
      editable: false,
      resizable: false,
      filter: false,
      sortable: false,
      lockPosition: true,
    },
    {
      headerName: 'Booking Id',
      field: 'ambulance_booking_id',
      editable: false,
      minWidth: 125,
      flex: 1,
      resizable: true,
      filter: true,
      sortable: true,
      lockPosition: true,
    },
    {
      headerName: 'Booking Date',
      valueGetter: (params: any) => {
        const rawDate = params.data?.booking_date;
        if (!rawDate) return '';
        const date = new Date(rawDate);
        return date.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          timeZone: 'Africa/Harare',
        });
      },
      editable: false,
      resizable: true,
      minWidth: 125,
      flex: 1,
      filter: true,
      sortable: true,
      comparator: (a: string = '', b: string = '') => a.localeCompare(b),
      lockPosition: true,
    },
    {
      headerName: 'Ambulance Type',
      field: 'ambulance_type',
      editable: false,
      minWidth: 155,
      flex: 2,
      resizable: true,
      filter: true,
      sortable: true,
      lockPosition: true,
      valueFormatter: (params) => {
        const typeMap: { [key: number]: string } = {
          1: 'Basic Life Support (BLS)',
          2: 'Intermediate Life Support (ILS)',
          3: 'Advanced Life Support (ALS)',
          4: 'Advanced Life Support with Intensive Care Nurse on Board (ALS with ICN)',
          5: 'Advanced Life Support with Doctor on Board (ALS with Dr )',
        };
        return typeMap[params.value] || 'N/A';
      },
    },
    {
      headerName: 'Pick-up',
      field: 'pickup_location',
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      lockPosition: true,
      valueFormatter: (params: any) => {
        const value = params.value?.trim();
        if (!value || value.toUpperCase() === 'N/A') {
          return 'N/A';
        }
        return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
      },
      comparator: (a: string = '', b: string = '') =>
        a.toLowerCase().localeCompare(b.toLowerCase()),
      flex: 1,
      minWidth: 120,
      cellRenderer: (params: any) => {
        const text = params.value ?? '';
        return `<span title="${text}" style="color: #000 !important" class="pickup-cell">${text}</span>`;
      },
    },
    {
      headerName: 'Drop-off',
      field: 'dropoff_location',
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      lockPosition: true,
      valueFormatter: (params: any) => {
        const value = params.value?.trim();
        if (!value || value.toUpperCase() === 'N/A') {
          return 'N/A';
        }
        return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
      },
      comparator: (a: string = '', b: string = '') =>
        a.toLowerCase().localeCompare(b.toLowerCase()),
      flex: 1,
      minWidth: 120,
      cellRenderer: (params: any) => {
        const text = params.value ?? '';
        return `<span title="${text}" style="color: #000 !important" class="pickup-cell">${text}</span>`;
      },
    },
    {
      headerName: 'Driver Id',
      field: 'driver_name',
      editable: false,
      resizable: true,
      minWidth: 120,
      flex: 1,
      filter: true,
      sortable: true,
      lockPosition: true,
    },
    {
      headerName: 'Status',
      field: 'ride_status',
      editable: false,
      resizable: true,
      minWidth: 120,
      flex: 1,
      filter: true,
      sortable: true,
      lockPosition: true,
      cellRenderer: (params: any) => {
        const status = params.data.ride_status?.toLowerCase();
        const statusIcons: Record<string, string> = {
          accepted: 'assets/img/ambulance/accepted.webp',
          completed: 'assets/img/ambulance/compelete.webp',
          new: 'assets/img/ambulance/New.webp',
          rejected: 'assets/img/ambulance/rejected.webp',
          'in review': 'assets/img/ambulance/inreview.webp',
          started: 'assets/img/ambulance/started.webp',
        };
        const iconUrl = statusIcons[status];
        return `
        <span style="display: flex; align-items: center; gap: 6px;">
          <img src="${iconUrl}" alt="${status}" style="width: 17px; height: 17px;" />
          <span style="text-transform: capitalize; color: black !important;">${params.value}</span>
        </span>`;
      },
    },
  ];

  constructor(
    private apiService: ApiService,
    private spinner: NgxSpinnerService
  ) {}
  ngOnInit() {
    this.userProfile = JSON.parse(localStorage.getItem('user') || '{}');
    this.subDetail = JSON.parse(localStorage.getItem('subDetail') || '{}');
    this.getReports(this.userProfile.user_id);
  }

  selectTab(index: number, id: any) {
    this.selectedTabIndex = index;
    this.selected_id = index === 0 ? 0 : id;
    this.tableData2 = [];
    if (this.paginationSubscription) {
      this.paginationSubscription.unsubscribe();
    }
    const targetId =
      this.selected_id !== 0 ? this.selected_id : this.userProfile.user_id;
    this.getReports(targetId);
  }

  getReports(id: any): void {
    this.apiService.getBookingAmbulanceHistory(id).subscribe({
      next: (apiRes: any) => {
        this.rowData = apiRes.data.map((item: any) => ({
          ambulance_booking_id: item.ambulance_booking_id ?? 'N/A',
          booking_date: item.booking_date ?? 'N/A',
          ambulance_type: item.ambulance_type_id ?? '',
          pickup_location: item.pickup_location ?? 'N/A',
          dropoff_location: item.dropoff_location ?? 'N/A',
          otp: item.otp ?? 'N/A',
          ride_status: item.ride_status ?? 'N/A',
          driver_name: item.driver_name ? item.driver_name : 'N/A',
        }));
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
        // this.toastrService.error('Failed to fetch ambulance data');
      },
    });
  }

  reload(data: any) {
    this.spinner.show();
    this.ngOnInit();
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
}
